import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Box from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Box';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import CommentaryCardPicker
  from 'Components/ComponentLibrary/Organisms/AccountPerformanceCommentaryCard/CommentaryCardPicker/CommentaryCardPicker';
import fr from 'facet-rest';

const styles = () => ({
  root: {
    maxHeight: 750,
  },
});

const AccountPerformanceCommentaryCard = ({
  className,
  classes,
  isHighlight,
  ...rest
}) => {
  return (
    <Box
      className={classNames(classes.root, className)}
    >
      <CommentaryCardPicker isHighlight={isHighlight} {...rest} />
    </Box>
  );
};

AccountPerformanceCommentaryCard.defaultProps = {
  className: '',
  chartData: undefined,
  isHighlight: false,
  showBenchmark: true,
  onClickDateRange: undefined,
  feedbackLink: undefined,
  handleOnFeedbackSubmitted: undefined,
};

AccountPerformanceCommentaryCard.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
  label: PropTypes.string.isRequired,
  startDate: PropTypes.string.isRequired,
  endDate: PropTypes.string.isRequired,
  performance: PropTypes.string.isRequired,
  benchmark: PropTypes.string.isRequired,
  commentary: PropTypes.string.isRequired,
  chartData: PropTypes.array,
  lastUpdated: PropTypes.string.isRequired,
  isHighlight: PropTypes.bool,
  showBenchmark: PropTypes.bool,
  onClickDateRange: PropTypes.func,
  feedbackLink: PropTypes.instanceOf(fr.Link),
  handleOnFeedbackSubmitted: PropTypes.func,
};

export default withStyles(styles)(AccountPerformanceCommentaryCard);
